import { datadogRum } from '@datadog/browser-rum';

import { getDatadogRumConfig } from '@/shared/utils/datadogRumConfig';

type AcaoContexto = Record<string, unknown>;

/**
 * Registra uma ação de negócio no Datadog RUM (`addAction`) — o caminho feliz, que
 * `reportError` não cobre. Silenciosa quando o RUM não está configurado ou ainda não
 * inicializou: telemetria de caminho feliz nunca derruba a ação do usuário.
 *
 * Devolve `true` só quando a ação foi entregue ao SDK, para quem deduplica não marcar como
 * contado o que nunca saiu.
 *
 * ⚠️ O payload é indexado: passe apenas identificadores e números. Nada de nome de
 * arquivo, nome de parte, descrição, conteúdo ou bytes (LGPD). O tenant já vem do
 * global context do RUM — não repita.
 */
export function registrarAcao(nome: string, contexto?: AcaoContexto): boolean {
  if (typeof window === 'undefined') return false;
  if (!getDatadogRumConfig()) return false;

  try {
    datadogRum.addAction(nome, contexto);
    return true;
  } catch {
    return false;
  }
}
